import { UIData } from '../../hooks/stores/uiStore';

interface SceneManipulationDependencies {
  UIData: UIData;
  setUIData: (data: Partial<UIData>) => void;
}

export function createSceneManipulationUtils({
  UIData,
  setUIData,
}: SceneManipulationDependencies) {
  const resetPosition = () => {
    setUIData({ sceneOffset: { x: 0, y: 0 } });
  };

  const zoomIn = () => {
    setUIData({
      sceneZoom: Math.min(3, +(UIData.sceneZoom + 0.1).toFixed(2)),
    });
  };

  const zoomOut = () => {
    setUIData({
      sceneZoom: Math.max(0.2, +(UIData.sceneZoom - 0.1).toFixed(2)),
    });
  };

  const resetZoom = () => {
    setUIData({ sceneZoom: 1 });
  };

  return {
    resetPosition,
    zoomIn,
    zoomOut,
    resetZoom,
  };
} 